/*
 * @Author: your name
 * @Date: 2021-06-24 11:07:32
 * @LastEditTime: 2021-06-28 11:32:18
 * @LastEditors: your name
 * @Description: yang
 * @FilePath: \web_bank\src\main.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css'
import {rem} from '../public/px2rem'
rem(window,document)

Vue.use(Vant);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
